import { stringIsBoolean, stringToBoolean } from "./helper-string";

type IDataForm = {
  name: string;
  dependency?: string;
  valueIfDependencyIsInvalid?: any;
  adapter?: any;
};

export const getListOfKeys = (obj: any): any => Object.keys(obj);

export const formatBooleanStringValues = (object: any): any => {
  const response = object;

  getListOfKeys(response).forEach((key: any) => {
    const currentValueIsBoolean = stringIsBoolean(response[key]);
    if (currentValueIsBoolean) {
      response[key] = stringToBoolean(response[key]);
    }
  });

  return response;
};

export const removeProperties = (obj: any, list: string[]): any => {
  const response = obj;
  list.forEach((key) => delete response[key]);
  return response;
};

export const formatObjectByDependencies = (obj: any, list: any): any => {
  const response = obj;
  getListOfKeys(response).forEach((key: any) => {
    const dependencyItem = list.find((d: any) => d.name === key);
    if (dependencyItem) {
      const dependencyIsValid =
        typeof response[dependencyItem.dependency] === "string"
          ? stringToBoolean(response[dependencyItem.dependency])
          : response[dependencyItem.dependency];
      if (!dependencyIsValid) delete response[key];
    }
  });
  return response;
};

export const formatDataForm = (dataForm: any, items: IDataForm[]): any => {
  // format all string boolean
  const obj = formatBooleanStringValues(dataForm);

  getListOfKeys(obj).forEach((key: any) => {
    const currentItem = items.find((i) => i.name === key);
    if (!currentItem) return;

    if (currentItem.adapter) {
      obj[key] = currentItem.adapter(obj[key]);
    }

    // Check if the dependency is valid, if it is valid it will be deleted
    if (!currentItem.dependency) return;
    const dependencyIsValid =
      typeof obj[currentItem.dependency] === "string" &&
      obj[currentItem.dependency];
    if (!dependencyIsValid) obj[key] = currentItem.valueIfDependencyIsInvalid;
  });

  return obj;
};

export const removeEmptyFields = (obj: any): any => {
  const data = obj;
  getListOfKeys(data).forEach((key: any) => {
    if (data[key] === null || data[key] === undefined || data[key] === "null") {
      delete data[key];
    }
  });
  return data;
};

export const formatFormikToValidate = (
  source: any,
  index: null | number = null,
  parentFieldName = ""
): any => {
  const response = {} as any;

  const prefix = index !== null ? `${parentFieldName}.${index}.` : "";

  getListOfKeys(source).forEach((fieldName: any) => {
    const currentFieldValue = source[fieldName];
    const currentFieldValueIsAList = Array.isArray(currentFieldValue);

    if (currentFieldValueIsAList) {
      currentFieldValue.forEach((childSource: any, idx: number) => {
        if (
          !(childSource instanceof String || typeof childSource === "string")
        ) {
          const newChildSource = formatFormikToValidate(
            childSource,
            idx,
            `${prefix}${fieldName}`
          );
          Object.assign(response, { ...newChildSource });
        } else {
          response[`${fieldName}`] = response[`${fieldName}`]
            ? [...response[`${fieldName}`], childSource]
            : [childSource];
        }
      });
    } else {
      response[`${prefix}${fieldName}`] = currentFieldValue;
    }
  });

  return response;
};
